(function () {
  var root = document.getElementById('hy-quiz');
  if (!root) return;
  var IMG = 'https://cdn.shopify.com/s/files/1/0952/1791/0093/files/';
  function im(name, v) { return IMG + name + '?v=' + v + '&width=600'; }

  var QUESTIONS = [
    { text: 'Il tuo meteo interiore di questa settimana?', weight: 1, answers: [
      { label: 'Si sta aprendo il cielo', key: 'TG', img: im('hy-quiz-q1-clouds.png', 1793657041) },
      { label: 'Temporale, ma sto imparando a ballarci sotto', key: 'IC', img: im('hy-quiz-q1-storm.png', 1793657041) },
      { label: 'Sole tiepido, me lo godo', key: 'VE', img: im('hy-quiz-q1-sunrise.png', 1793657041) },
      { label: 'Variabile, ma oggi c’è il sole', key: 'ME', img: im('hy-quiz-q1-variable.png', 1793737113) } ] },
    { text: 'Quando la giornata diventa troppo, tu…', weight: 1, answers: [
      { label: 'Fai battute finché nessuno se ne accorge', key: 'ME', img: im('hy-quiz-q2-jokes.png', 1793657041) },
      { label: 'Esci a camminare senza meta', key: 'VE', img: im('hy-quiz-q2-walk.png', 1793657040) },
      { label: 'Metti le cuffie e respiri finché passa', key: 'IC', img: im('hy-quiz-q2-headphones.png', 1793657041) },
      { label: 'Chiami la tua persona', key: 'TG', img: im('hy-quiz-q2-call.png', 1793657041) } ] },
    { text: 'Il tuo rifugio preferito quando serve?', hint: 'Sii onesto. Nessuno ti giudica.', weight: 0.5, answers: [
      { label: 'Snack e una serie già vista mille volte', key: 'VE', img: im('hy-quiz-q3-snacks.png', 1793657040) },
      { label: 'Mandare meme a raffica al gruppo', key: 'TG', img: im('hy-quiz-q3-memes.png', 1793657041) },
      { label: 'Pulire casa alle 2 di notte', key: 'ME', img: im('hy-quiz-q3-broom.png', 1793657040) },
      { label: 'Playlist triste a volume massimo', key: 'IC', img: im('hy-quiz-q3-earphones.png', 1793657041) } ] },
    { text: 'La frase che ti meriti di sentire oggi?', weight: 2, textOnly: true, answers: [
      { label: '“Le tue paure sono più piccole di te.”', key: 'ME' },
      { label: '“Chiedere aiuto è roba da coraggiosi.”', key: 'TG' },
      { label: '“Hai attraversato tempeste peggiori.”', key: 'IC' },
      { label: '“Il mondo ha bisogno della tua gentilezza.”', key: 'VE' } ] },
    { text: 'Se la tua forza fosse un oggetto, sarebbe…', weight: 1, answers: [
      { label: 'Un’ancora nel mare mosso', key: 'IC', img: im('hy-quiz-q5-anchor.png', 1793657040) },
      { label: 'Un fiore che cresce nel cemento', key: 'VE', img: im('hy-quiz-q5-flower.png', 1793657040) },
      { label: 'Uno scudo che riflette', key: 'ME', img: im('hy-quiz-q5-shield.png', 1793657040) },
      { label: 'Una chiave', key: 'TG', img: im('hy-quiz-q5-key.png', 1793657040) } ] }
  ];

  var RESULTS = {
    IC: { name: 'Il respiro nella tempesta', tee: 'Inner Chaos',
      power: 'Hai imparato che il caos passa, e tu resti. Il tuo superpotere è la calma conquistata.',
      letter: 'Lo so com’è: il cuore che corre e tu che sorridi lo stesso, perché nessuno se ne accorga. In cinque anni di terapia ho imparato una cosa sola, ma vera: la tempesta passa. E dall’altra parte ci sei sempre tu, un po’ più forte di come ti ha trovato. Respira. Passerà.',
      url: '/products/black-oversized-boxy-fit-t-shirt-inner-chaos',
      img: 'https://cdn.shopify.com/s/files/1/0952/1791/0093/files/hydecor-t-shirt-nera-boxy-fit-drop-shoulder-dark-art_3.png?v=1775335523&width=900',
      next: 'TG', why: 'Dopo la tempesta, il coraggio di dirlo ad alta voce.' },
    ME: { name: 'Lo sguardo che non scappa', tee: 'Medusa',
      power: 'Guardi in faccia quello che gli altri evitano. Il tuo superpotere è il coraggio silenzioso.',
      letter: 'Scappare sarebbe più facile. Tu invece resti, e guardi. È la cosa più difficile che esista, e la fai senza farne un caso. I mostri diventano più piccoli quando li fissi negli occhi. Indossali, e smetti di nasconderti.',
      url: '/products/medusa-graffiti-graphic-oversized-t-shirt',
      img: 'https://cdn.shopify.com/s/files/1/0952/1791/0093/files/oversized-streetwear-t-shirt-medusa-graffiti-rope-detail_6.png?v=1777821767&width=900',
      next: 'TG', why: 'Dopo aver guardato i mostri, la scelta di non affrontarli da solo.' },
    TG: { name: 'La voce che chiede', tee: 'Thank Goodness',
      power: 'Hai capito che non si vince da soli. Il tuo superpotere è il coraggio di farsi aiutare.',
      letter: 'Per anni ho tenuto dentro una frase: “vedo uno psicologo”. Poi un giorno ci ho messo davanti due parole, “per fortuna”, ed è cambiato tutto. Tu l’hai già capito. Chiedere non è debolezza. È la mossa più forte che ci sia.',
      url: '/products/thank-goodness-oversized-tee',
      img: 'https://cdn.shopify.com/s/files/1/0952/1791/0093/files/unisex-oversized-garment-dyed-t-shirt-washed-black-back-69d185777abcb_4.png?v=1775339200&width=900',
      next: 'VE', why: 'Dopo aver chiesto aiuto, la libertà di restare morbido.' },
    VE: { name: 'La gentilezza che non si spezza', tee: 'Venus',
      power: 'In un mondo duro, resti morbido. Il tuo superpotere è la tua sensibilità.',
      letter: 'Viviamo in un mondo che confonde la freddezza con la forza. Tu no. Resti gentile anche quando sarebbe più comodo indurirti. Non è fragilità. Oggi è la cosa più ribelle che si possa fare.',
      url: '/products/unisex-oversized-box-tee-t-shirt-with-botticellis-venus-graphic-print',
      img: 'https://cdn.shopify.com/s/files/1/0952/1791/0093/files/142.png?v=1781450501&width=900',
      next: 'TG', why: 'La gentilezza più grande: quella verso te stesso.' }
  };

  var screens = root.querySelectorAll('[data-screen]');
  var step = 0, picks = [], order = [], locked = false;
  function $(id) { return document.getElementById(id); }

  function show(name) {
    screens.forEach(function (s) { s.hidden = s.getAttribute('data-screen') !== name; });
    root.classList.toggle('is-result', name === 'result');
    try { root.scrollIntoView({ block: 'start' }); } catch (e) {}
  }
  function shuffle(a) {
    a = a.slice();
    for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[j]; a[j] = t; }
    return a;
  }

  function renderQuestion() {
    var q = QUESTIONS[step];
    locked = false;
    $('hy-q-count').textContent = (step + 1) + ' / ' + QUESTIONS.length;
    $('hy-q-back').disabled = step === 0;
    root.querySelectorAll('#hy-q-progress span').forEach(function (s, i) { s.className = i < step ? 'done' : (i === step ? 'now' : ''); });
    $('hy-q-text').textContent = q.text;
    var hint = $('hy-q-hint');
    hint.hidden = !q.hint && !q.textOnly;
    hint.textContent = q.hint ? q.hint : (q.textOnly ? 'Scegli quella che ti arriva per prima.' : '');
    var box = $('hy-q-answers');
    box.innerHTML = '';
    var list = document.createElement('div');
    list.className = q.textOnly ? 'q-list' : 'q-grid';
    order[step].forEach(function (a) {
      var b = document.createElement('button');
      b.type = 'button';
      if (q.textOnly) { b.className = 'q-line'; b.textContent = a.label; }
      else {
        b.className = 'q-card';
        var img = document.createElement('img'); img.src = a.img; img.alt = '';
        var lab = document.createElement('span'); lab.className = 'q-label'; lab.textContent = a.label;
        b.appendChild(img); b.appendChild(lab);
      }
      b.addEventListener('click', function () { pick(a, b, list); });
      list.appendChild(b);
    });
    box.appendChild(list);
    show('question');
    var nq = QUESTIONS[step + 1];
    if (nq && !nq.textOnly) nq.answers.forEach(function (a) { var i = new Image(); i.src = a.img; });
  }

  function pick(answer, btn, list) {
    if (locked) return;
    locked = true;
    btn.classList.add('picked');
    list.classList.add('locked');
    picks[step] = answer.key;
    try { if (navigator.vibrate) navigator.vibrate(12); } catch (e) {}
    setTimeout(function () { step++; if (step < QUESTIONS.length) renderQuestion(); else finish(); }, 520);
  }

  function score() {
    var pts = { IC: 0, ME: 0, TG: 0, VE: 0 };
    picks.forEach(function (k, i) { pts[k] += QUESTIONS[i].weight; });
    var best = Object.keys(pts).sort(function (a, b) { return pts[b] - pts[a]; });
    var top = pts[best[0]];
    var tied = best.filter(function (k) { return pts[k] === top; });
    if (tied.length > 1 && tied.indexOf(picks[3]) !== -1) return picks[3];
    return tied[0];
  }

  function finish() {
    show('loading');
    var key = score();
    var r = RESULTS[key], n = RESULTS[r.next];
    var pre = new Image(); pre.src = r.img;
    setTimeout(function () {
      $('hy-q-r-img').src = r.img;
      $('hy-q-r-img').alt = 'Maglietta Hydecor ' + r.tee;
      $('hy-q-r-name').textContent = r.name;
      $('hy-q-r-power').textContent = r.power;
      var letter = $('hy-q-r-letter');
      letter.textContent = r.letter;
      var sig = document.createElement('strong'); sig.textContent = '— Fabio, Hydecor';
      letter.appendChild(sig);
      $('hy-q-r-shop').href = r.url;
      $('hy-q-r-shop').textContent = 'Scopri ' + r.tee;
      $('hy-q-r-next').href = n.url;
      $('hy-q-n-img').src = n.img;
      $('hy-q-n-img').alt = 'Maglietta Hydecor ' + n.tee;
      $('hy-q-n-name').textContent = n.tee;
      $('hy-q-n-why').textContent = r.why;
      $('hy-q-toast').textContent = '';
      root.setAttribute('data-result', key);
      show('result');
    }, 1500);
  }

  function start() {
    step = 0; picks = [];
    order = QUESTIONS.map(function (q) { return shuffle(q.answers); });
    renderQuestion();
  }

  $('hy-q-start').addEventListener('click', start);
  $('hy-q-restart').addEventListener('click', start);
  $('hy-q-back').addEventListener('click', function () { if (step > 0) { step--; renderQuestion(); } });

  function wrap(ctx, text, x, y, max, lh) {
    var words = text.split(' '), line = '', lines = [];
    words.forEach(function (w) { var t = line ? line + ' ' + w : w; if (ctx.measureText(t).width > max && line) { lines.push(line); line = w; } else { line = t; } });
    lines.push(line);
    lines.forEach(function (l, i) { ctx.fillText(l, x, y + i * lh * 0.95); });
  }

  $('hy-q-share').addEventListener('click', function () {
    var toast = $('hy-q-toast');
    var r = RESULTS[root.getAttribute('data-result')];
    var fallback = 'Fai uno screenshot della card qui sopra e postala nelle storie.';
    toast.textContent = 'Preparo la tua card…';
    var img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = function () {
      try {
        var c = document.createElement('canvas'); c.width = 1080; c.height = 1920;
        var x = c.getContext('2d');
        x.fillStyle = '#0a0a0a'; x.fillRect(0, 0, 1080, 1920);
        var glow = x.createRadialGradient(540, 700, 40, 540, 700, 1100);
        glow.addColorStop(0, 'rgba(227,179,108,.28)'); glow.addColorStop(.5, 'rgba(176,74,63,.10)'); glow.addColorStop(1, 'rgba(10,10,10,0)');
        x.fillStyle = glow; x.fillRect(0, 0, 1080, 1920);
        var s = Math.max(1080 / img.width, 1500 / img.height);
        var w = img.width * s, h = img.height * s;
        x.drawImage(img, (1080 - w) / 2, 120 + (1500 - h) / 2, w, h);
        var g = x.createLinearGradient(0, 900, 0, 1920);
        g.addColorStop(0, 'rgba(10,10,10,0)'); g.addColorStop(0.55, 'rgba(10,10,10,.95)'); g.addColorStop(1, '#0a0a0a');
        x.fillStyle = g; x.fillRect(0, 900, 1080, 1020);
        x.textBaseline = 'top';
        x.fillStyle = '#f5f5f5'; x.font = '34px Abel, Arial'; x.fillText('HYDECOR', 72, 72);
        x.fillStyle = '#e3b36c'; x.font = '40px Abel, Arial'; x.fillText('IL MIO TIPO DI FORZA', 72, 1380);
        x.fillStyle = '#f5f5f5'; x.font = '104px Abel, Arial'; wrap(x, r.name.toUpperCase(), 72, 1440, 936, 104);
        x.fillStyle = 'rgba(245,245,245,.6)'; x.font = '38px Abel, Arial'; x.fillText('Che armatura indossi? · hydecor.it/pages/quiz', 72, 1800);
        c.toBlob(function (blob) {
          var file = new File([blob], 'hydecor-armatura.png', { type: 'image/png' });
          if (navigator.canShare && navigator.canShare({ files: [file] })) {
            navigator.share({ files: [file], title: 'Che armatura indossi?' }).then(function () { toast.textContent = ''; }).catch(function () { toast.textContent = ''; });
          } else {
            var a = document.createElement('a');
            a.href = URL.createObjectURL(blob); a.download = 'hydecor-armatura.png';
            document.body.appendChild(a); a.click(); a.remove();
            toast.textContent = 'Card salvata. Caricala nelle tue storie.';
          }
        }, 'image/png');
      } catch (e) { toast.textContent = fallback; }
    };
    img.onerror = function () { toast.textContent = fallback; };
    img.src = r.img;
  });
})();
